module.exports = __webpack_public_path__ + "static/035_Gippsland_sm-0269dd6f4dd927d5dd4ed4b05959f188.png";